var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temItens
    ? _c(
        "div",
        { staticClass: "suggestion-chips" },
        _vm._l(_vm.itens, function(item) {
          return _c(
            "button",
            {
              key: item.chave,
              staticClass: "suggestion-chips__pilula ia-texto-corpo",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.usar(item.texto)
                }
              }
            },
            [_vm._v(" " + _vm._s(item.texto) + " ")]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }